import { e as __rest, c as __assign } from '../../../../../tslib.es6-80f01feb.js';
import React__default from 'react';

var FairnessButton = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? 'security' : _b, children = _a.children, text = _a.text, rest = __rest(_a, ["iconName", "children", "text"]);
    return (React__default.createElement("div", __assign({ className: 'pgc-fairness-tab' }, rest),
        React__default.createElement("i", { className: "icon-".concat(iconName) }),
        React__default.createElement("span", null, text),
        children));
};

export { FairnessButton };
